// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  .item {
    /* width:40px; */
    height: 36px;
    left: 3px;
    /* left: -3px; */
    transform: translate3d(0, 0, 0);
    transition: transform, opacity ease-out 200ms;
    transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
    transition-duration: 180ms;
    position: absolute;
    cursor: pointer;
    top:5px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    z-index: 9999;
  }
  .item.disabled {
    pointer-events: none;
  }
  .item.disabled .fab-item {
    background-color: lightgray;
  }
  .content {
    z-index: 9999;
    background: rgba(68,138,255, 1);
    margin-left: 0px;
    line-height: 25px;
    color: white;
    /* text-transform: lowercase; */
    padding: 5px 20px 3px 20px;
    border-top-right-radius: 18px;
    border-bottom-right-radius: 18px;
    border-bottom-left-radius: 18px;
    border-top-left-radius: 18px;
    display: none;
    font-size: 13px;
    height: 28px;
    /* margin-top: 4px; */
    box-shadow: 0 2px 5px 0 rgba(0,0,0,.26);
    white-space:nowrap;
  }
  .fab-item {
    left: 0;
    background: rgba(68,138,255, 1);
    border-radius: 100%;
    width: 36px;
    height: 36px;
    position: absolute;
    color: white;
    text-align: center;
    cursor: pointer;
    line-height: 50px;
    /* box-shadow: 0 2px 5px 0 rgba(0,0,0,.26); */
  }
  .fab-item-ex {
    top: 0;
    background: rgba(68,138,255, 1);
    border-radius: 100%;
    width: 36px;
    height: 36px;
    position: absolute;
    color: white;
    text-align: center;
    cursor: pointer;
    line-height: 45px;
    /* box-shadow: 0 2px 5px 0 rgba(0,0,0,.26); */
  }
  .fab-item img {
    padding-bottom: 2px;
    padding-left: 5px;
  }
  `, "",{"version":3,"sources":["webpack://./src/app/gui-helpers/fab-button/ngx-fab-item-button.component.ts"],"names":[],"mappings":";EACE;IACE,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,+BAA+B;IAC/B,6CAA6C;IAC7C,8DAA8D;IAC9D,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;IACf,OAAO;IACP,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,aAAa;IACb,+BAA+B;IAC/B,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,+BAA+B;IAC/B,0BAA0B;IAC1B,6BAA6B;IAC7B,gCAAgC;IAChC,+BAA+B;IAC/B,4BAA4B;IAC5B,aAAa;IACb,eAAe;IACf,YAAY;IACZ,qBAAqB;IACrB,uCAAuC;IACvC,kBAAkB;EACpB;EACA;IACE,OAAO;IACP,+BAA+B;IAC/B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,6CAA6C;EAC/C;EACA;IACE,MAAM;IACN,+BAA+B;IAC/B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,6CAA6C;EAC/C;EACA;IACE,mBAAmB;IACnB,iBAAiB;EACnB","sourcesContent":["\n  .item {\n    /* width:40px; */\n    height: 36px;\n    left: 3px;\n    /* left: -3px; */\n    transform: translate3d(0, 0, 0);\n    transition: transform, opacity ease-out 200ms;\n    transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);\n    transition-duration: 180ms;\n    position: absolute;\n    cursor: pointer;\n    top:5px;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    z-index: 9999;\n  }\n  .item.disabled {\n    pointer-events: none;\n  }\n  .item.disabled .fab-item {\n    background-color: lightgray;\n  }\n  .content {\n    z-index: 9999;\n    background: rgba(68,138,255, 1);\n    margin-left: 0px;\n    line-height: 25px;\n    color: white;\n    /* text-transform: lowercase; */\n    padding: 5px 20px 3px 20px;\n    border-top-right-radius: 18px;\n    border-bottom-right-radius: 18px;\n    border-bottom-left-radius: 18px;\n    border-top-left-radius: 18px;\n    display: none;\n    font-size: 13px;\n    height: 28px;\n    /* margin-top: 4px; */\n    box-shadow: 0 2px 5px 0 rgba(0,0,0,.26);\n    white-space:nowrap;\n  }\n  .fab-item {\n    left: 0;\n    background: rgba(68,138,255, 1);\n    border-radius: 100%;\n    width: 36px;\n    height: 36px;\n    position: absolute;\n    color: white;\n    text-align: center;\n    cursor: pointer;\n    line-height: 50px;\n    /* box-shadow: 0 2px 5px 0 rgba(0,0,0,.26); */\n  }\n  .fab-item-ex {\n    top: 0;\n    background: rgba(68,138,255, 1);\n    border-radius: 100%;\n    width: 36px;\n    height: 36px;\n    position: absolute;\n    color: white;\n    text-align: center;\n    cursor: pointer;\n    line-height: 45px;\n    /* box-shadow: 0 2px 5px 0 rgba(0,0,0,.26); */\n  }\n  .fab-item img {\n    padding-bottom: 2px;\n    padding-left: 5px;\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
